import { getHours, getMinutes } from "date-fns";

import { parseTime } from "@app/util/parsers";

import EmailSendingWindow from "../types/EmailSendingWindow";

const HOURS_PER_DAY = 24;
const MINUTES_PER_HOUR = 60;

const toTotalMinutes = (date: Date): number => getHours(date) * MINUTES_PER_HOUR + getMinutes(date);

/**
 * Creates a disabledTime callback for antd's TimeDropdownPicker.
 * Disables hours/minutes outside the sendingWindow and optionally before minTime.
 * A window time of "00:00" naturally means no restriction (0 total minutes).
 */
const createDisabledTime = (sendingWindow: EmailSendingWindow, minTime?: Date) => {
  const windowStart = toTotalMinutes(parseTime(sendingWindow.startTime));
  const windowEnd = toTotalMinutes(parseTime(sendingWindow.endTime));
  const minTimeMinutes = minTime ? toTotalMinutes(minTime) : 0;

  const effectiveMin = Math.max(minTimeMinutes, windowStart);
  const effectiveMax = windowEnd || null;

  if (!effectiveMin && effectiveMax === null) {
    return undefined;
  }

  return () => ({
    disabledHours: () => {
      const disabled: number[] = [];
      for (let hour = 0; hour < HOURS_PER_DAY; hour++) {
        const hourStart = hour * MINUTES_PER_HOUR;
        const hourEnd = hourStart + MINUTES_PER_HOUR - 1;
        if (hourEnd < effectiveMin || (effectiveMax !== null && hourStart > effectiveMax)) {
          disabled.push(hour);
        }
      }
      return disabled;
    },
    disabledMinutes: (hour: number) => {
      const disabled: number[] = [];
      for (let minute = 0; minute < MINUTES_PER_HOUR; minute++) {
        const total = hour * MINUTES_PER_HOUR + minute;
        if (total < effectiveMin || (effectiveMax !== null && total > effectiveMax)) {
          disabled.push(minute);
        }
      }
      return disabled;
    },
  });
};

export default createDisabledTime;
